"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M43.953 14.125l-10.1-10.1a2 2 0 0 0-2.828 0l-5.391 5.397L14.1 14.963l-.179.09a4.491 4.491 0 0 0-2 2.3l-8.262 20.71a2 2 0 0 0 .435 2.147l3.64 3.69a2 2 0 0 0 2.162.452l20.681-8.23a4.726 4.726 0 0 0 2.471-2.222l5.579-11.619 5.326-5.326a2 2 0 0 0 0-2.83zM29.84 32.266a1.072 1.072 0 0 1-.579.5L9.333 41.055l-.507-.5 9.932-9.932a3.215 3.215 0 1 0-1.414-1.415L7.4 39.147l-.472-.466 8.346-20.029a.911.911 0 0 1 .377-.443L27.96 12.3l7.75 7.75z" })
);

